"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const stockpile_1 = require("services/stockpile");
const stockpile_pos_types_1 = require("./stockpile-pos.types");
const getLandingPageStockpile = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, stockpile_1._getLandingPageStockpile)(payload);
    if (response.isError) {
        dispatch({
            type: stockpile_pos_types_1.stockpilePosTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        const payload = {
            DeviceData: response.data.DeviceData,
            countDataTransaction: response.countDataTransaction,
            TransactionDataStockpile: response.data.TransactionDataStockpile,
            ConfigurationCheckPointData: response.data.ConfigurationCheckPointData
        };
        dispatch({ type: stockpile_pos_types_1.stockpilePosTypes.GET_LANDING_PAGE_DATA_STOCKPILE, payload });
    }
});
const toggleError = payload => dispatch => {
    dispatch({ type: stockpile_pos_types_1.stockpilePosTypes.SET_ERROR, payload });
};
const toggleLoading = payload => dispatch => {
    dispatch({ type: stockpile_pos_types_1.stockpilePosTypes.SET_LOADING, payload });
};
const resetSelectedPos = payload => dispatch => {
    dispatch({ type: stockpile_pos_types_1.stockpilePosTypes.RESET_SELECTED_POS, payload });
};
exports.default = {
    toggleError,
    toggleLoading,
    resetSelectedPos,
    getLandingPageStockpile
};
